"use strict";

import angular from "angular";

import template from "./chart-comparation.component.html";
import "./themes/chart-comparation.component-dark.scss";
import "./themes/chart-comparation.component.scss";

import _ from "lodash";

import { Point } from "../../../gateway/Point/Point";
import { PointCalculated } from "../../../gateway/PointCalculated/PointCalculated";
import { Serie } from "../../../gateway/Serie/Serie";
import { CalculatingMachine } from "../../../presentation/services/CalculatingMachine/CalculatingMachine";
import * as DateUtils from "../../../utils/date/date";

class ChartComparationComponent {
    constructor($stateParams) {
        this.SerieDomain = new Serie();
        this.PointDomain = new Point();
        this.PointCalculatedDomain = new PointCalculated();
        this.CalculatingMachine = new CalculatingMachine({
            Serie: this.SerieDomain,
            Point: this.PointDomain,
            PointCalculated: this.PointCalculatedDomain
        });

        this.companyId = $stateParams.id;

        this.seriesWithPoints = [];
        this.visualization = {};
    }

    $onInit() {
        this._setVisualization();
    }

    $onChanges(changes) {
        if (
            !_.isEmpty(_.get(changes, "currentPeriod.previousValue")) ||
            !_.isEmpty(_.get(changes, "currentComparation.previousValue")) ||
            (this.fakeData && changes.series)
        ) {
            this._setVisualization();
        }
    }

    _setVisualization() {
        if (this.projection || this.budget || this.goals)
            this._setVisualizationChart();
        else this._setVisualizationDefault();
    }

    _setVisualizationChart() {
        const getSeriesReference = () => {
            const seriesReferences = this.visualizationData?.series;
            return seriesReferences.map((serieId, i) => {
                const serie = this.configs.series.find(
                    (s) => s._id === serieId
                );
                return {
                    _id: serie._id,
                    color: serie.color?.replace("-", ".")
                };
            });
        };

        const struture = {
            chart: {
                title: {
                    text: ""
                },
                credits: {
                    enabled: false
                },
                exporting: {
                    enabled: false
                },
                chart: {
                    type: "column"
                },
                plotOptions: {
                    series: {
                        borderWidth: 0
                    }
                },
                yAxis: { title: { text: "" } },
                legend: {
                    enabled: true
                },
                series: getSeriesReference()
            }
        };

        if (
            this.goals &&
            this.visualizationData?.component?.configs?.goals?.length
        ) {
            struture.chart.goals = this.visualizationData?.component?.configs?.goals.map(
                (goal) => {
                    goal.type = "line";
                    goal.color = goal.color?.replace("-", ".");
                    return goal;
                }
            );
        }

        this.visualization = struture;
    }

    _setVisualizationDefault() {
        this._setSeries();
        this._setComparationLabel();
    }

    /**
     * @private
     * Setta a label de comparacao
     * @param {Object} period
     * @param {Object} comparation
     */
    _setComparationLabel = (
        period = this.currentPeriod,
        comparation = this.currentComparation
    ) => {
        this.comparationLabel = DateUtils.getComparationLabel(
            period,
            comparation
        );
    };

    /**
     * @private
     * Setta os dados das series e points
     */
    _setSeries() {
        if (!this.series) return;
        this.CalculatingMachine.setSource(this.source);

        const seriesWithPoints = this.CalculatingMachine.comparation({
            series: this.series,
            companyId: this.companyId,
            xFilter: this.currentPeriod,
            yFilter: this.currentComparation,
            fakeData: this.fakeData
        });

        this.seriesWithPoints = seriesWithPoints.map((serie) => {
            serie.color = _.get(
                _.find(_.get(this.configs, "series"), { _id: serie._id }),
                "color"
            );
            serie.color = _.replace(serie.color, ".", "-");

            return serie;
        });
    }
}

ChartComparationComponent.$inject = ["$stateParams"];

const name = "chartComparationComponent";
const def = {
    bindings: {
        series: "<",
        points: "<",
        configs: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        fakeData: "<",
        projection: "<",
        budget: "<",
        goals: "<",
        visualizationData: "<"
    },
    controller: ChartComparationComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
